import React, { useState } from "react";
import InputTextWithSwitch from "./InputTextWithSwitch";
import GradientButton from "../Button/GradientButton";
import { DownloadIcon, ShareIcon } from "../../utils/icons";

// const downloadIcon = (
//   <svg
//     width="21"
//     height="20"
//     viewBox="0 0 21 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M3.83203 14.168V15.8346C3.83203 16.7551 4.57822 17.5013 5.4987 17.5013H15.4987C16.4192 17.5013 17.1654 16.7551 17.1654 15.8346V14.168"
//       stroke="#F1F3F4"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M6.33203 9.16797L10.4987 13.3346L14.6654 9.16797"
//       stroke="#F1F3F4"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M10.4987 3.33203V13.332"
//       stroke="#F1F3F4"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const ShareIcon = (
//   <svg
//     width="20"
//     height="21"
//     viewBox="0 0 20 21"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <circle
//       cx="5"
//       cy="10.5"
//       r="2.5"
//       stroke="url(#paint0_linear_1279_28564)"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <circle
//       cx="15"
//       cy="5.5"
//       r="2.5"
//       stroke="url(#paint1_linear_1279_28564)"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <circle
//       cx="15"
//       cy="15.5"
//       r="2.5"
//       stroke="url(#paint2_linear_1279_28564)"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M7.25 9.41536L12.75 6.58203"
//       stroke="url(#paint3_linear_1279_28564)"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M7.25 11.582L12.75 14.4154"
//       stroke="url(#paint4_linear_1279_28564)"
//       strokeWidth="1.5"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <defs>
//       <linearGradient
//         id="paint0_linear_1279_28564"
//         x1="7.5"
//         y1="10.4771"
//         x2="2.5"
//         y2="10.4771"
//         gradientUnits="userSpaceOnUse"
//       >
//         <stop stopColor="#E3302E" />
//         <stop offset="0.447917" stopColor="#FF6B38" />
//         <stop offset="1" stopColor="#FFA380" />
//       </linearGradient>
//       <linearGradient
//         id="paint1_linear_1279_28564"
//         x1="17.5"
//         y1="5.47707"
//         x2="12.5"
//         y2="5.47707"
//         gradientUnits="userSpaceOnUse"
//       >
//         <stop stopColor="#E3302E" />
//         <stop offset="0.447917" stopColor="#FF6B38" />
//         <stop offset="1" stopColor="#FFA380" />
//       </linearGradient>
//       <linearGradient
//         id="paint2_linear_1279_28564"
//         x1="17.5"
//         y1="15.4771"
//         x2="12.5"
//         y2="15.4771"
//         gradientUnits="userSpaceOnUse"
//       >
//         <stop stopColor="#E3302E" />
//         <stop offset="0.447917" stopColor="#FF6B38" />
//         <stop offset="1" stopColor="#FFA380" />
//       </linearGradient>
//       <linearGradient
//         id="paint3_linear_1279_28564"
//         x1="12.75"
//         y1="7.9857"
//         x2="7.25"
//         y2="7.9857"
//         gradientUnits="userSpaceOnUse"
//       >
//         <stop stopColor="#E3302E" />
//         <stop offset="0.447917" stopColor="#FF6B38" />
//         <stop offset="1" stopColor="#FFA380" />
//       </linearGradient>
//       <linearGradient
//         id="paint4_linear_1279_28564"
//         x1="12.75"
//         y1="12.9857"
//         x2="7.25"
//         y2="12.9857"
//         gradientUnits="userSpaceOnUse"
//       >
//         <stop stopColor="#E3302E" />
//         <stop offset="0.447917" stopColor="#FF6B38" />
//         <stop offset="1" stopColor="#FFA380" />
//       </linearGradient>
//     </defs>
//   </svg>
// );

const CvCustomization = () => {
  const [items, setItems] = useState([
    { id: 1, title: "Allow Certifications", selected: true },
    { id: 2, title: "Allow Educational Experience", selected: true },
    { id: 3, title: "Allow Work Experience", selected: true },
    { id: 4, title: "Allow Personal Information", selected: true },
    { id: 5, title: "Allow Portfolio Links", selected: true },
  ]);

  const handleChange = (id, value) => {
    const updatedItems = items.map((item) => {
      if (item.id === id) {
        return { ...item, selected: value };
      }
      return item;
    });
    console.log(updatedItems, " = Privacy Management");
    setItems(updatedItems);
  };

  return (
    <div className="bg-pureWhite rounded-[16px] px-3 py-5 flex flex-col gap-y-4">
      <p className="text-lg font-medium">CV Customization</p>
      {items.map((item) => (
        <InputTextWithSwitch
          id={item.id}
          text={item.title}
          key={item.id}
          selected={item.selected}
          handleChange={handleChange}
        />
      ))}
      <GradientButton>
        <span className="downloadIcon">{DownloadIcon}</span>
        <span className="">Download CV</span>
      </GradientButton>
      <button className="rounded-full px-8 border-[3px] border-darkOrange hover:border-darkerOrange flex items-center py-[6px] justify-center gap-x-4">
        <span>{ShareIcon}</span>
        <span className="text-orange-gradient">Share</span>
      </button>
    </div>
  );
};

export default CvCustomization;
